import React from 'react';

const MaintenancePage = () => {
  return (
    <div className="maintenance-page">
      {/* Rain Video Background */}
      <div className="maintenance-video-bg">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="maintenance-video"
        >
          <source 
            src="https://videos.pexels.com/video-files/2491284/2491284-uhd_2560_1440_24fps.mp4" 
            type="video/mp4" 
          />
        </video>
        <div className="maintenance-overlay"></div>
      </div>

      {/* Content */}
      <div className="maintenance-content">
        <img 
          src="https://customer-assets.emergentagent.com/job_6b527816-b6b7-465f-902c-273e62ac9c37/artifacts/3xj9zj26_WASHED-AWAY_LOGO_FINAL_WHITE_Retina.png"
          alt="Washed Away"
          className="maintenance-logo"
        />
        
        <div className="maintenance-message">
          <h1>We'll Be Right Back</h1>
          <div className="maintenance-divider"></div>
          <p className="maintenance-text">
            We're experiencing some technical difficulties and our team is working 
            to restore service. Thank you for your patience — we'll be back online 
            very shortly.
          </p>
          <p className="maintenance-contact">
            Questions? Email us at <a href="mailto:support@washedaway.au">support@washedaway.au</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
